import { useT } from '@/i18n';
import { Navbar, Page } from 'framework7-react';
import TableSessionInspector from '../components/TableSessionInspector';
import { useTableSession } from '../hooks/useTableOrdering';

/** Phone route: a selected table's tab pushed as its own page (native back
 *  swipe / navbar transition). Wide layouts dock the inspector instead and
 *  never navigate here. The navbar title is the table the operator is in -
 *  the same `useTableSession` cache the inspector reads, so no extra request. */
export default function TableSessionDetailPage({
  f7route,
}: {
  f7route: { params: { sessionId: string } };
}) {
  const tAll = useT();
  const t = tAll.tableOrdering.workspace;
  const sessionId = f7route.params.sessionId;
  const { data: session } = useTableSession(sessionId);
  return (
    <Page name="table-session">
      <Navbar title={session?.tableLabel ?? t.tabFallback} backLink={tAll.back} />
      <TableSessionInspector sessionId={sessionId} />
    </Page>
  );
}
